export const MostlyClearIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="717277" strokeWidth="3" fill="none" fillRule="evenodd">
            <g transform="translate(3.000000, 11.000000)">
                <path
                    d="M46.94 50.158l-.097-.024-.098-.01c-3.362-.376-5.924-3.185-5.924-6.535 0-3.363 2.573-6.155 5.913-6.533l.992-.112.28-.958c1.258-4.317 5.307-7.426 10.036-7.426 4.71 0 8.75 3.084 10.024 7.382l.266.894.92.157c3.181.544 5.58 3.274 5.58 6.537 0 3.651-3.005 6.635-6.745 6.635H47.003a.263.263 0 01-.064-.007z"
                    stroke="#717277"
                    strokeWidth="3"
                />
                <path
                    d="M34.105 14.78c.102.016.138.05.155.069.026.03.055.083.063.158a.287.287 0 01-.028.169c-.012.022-.04.063-.135.1C25.766 18.5 20.11 26.64 20.11 35.848c0 12.142 9.753 22.004 21.805 22.004 2.934 0 5.788-.585 8.438-1.708.094-.04.142-.03.167-.022a.287.287 0 01.137.102c.046.06.063.12.064.16 0 .024-.001.073-.064.155-4.863 6.286-12.304 10.03-20.354 10.03C16.061 66.569 4.5 54.922 4.5 40.534 4.5 26.148 16.061 14.5 30.303 14.5c1.282 0 2.552.094 3.802.28z"
                    stroke="#717277"
                    strokeWidth="3"
                />
            </g>
        </g>
    </svg>
);
